import styled from "styled-components";

export const Wrapper = styled('div') <{ isGalleryEmpty: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
`